




































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class SlideOut extends Vue {
  @Prop({ default: false }) readonly slideoutOpen!: boolean;

  @Prop({ default: '600px' }) readonly sliderWidth!: string;

  private close() {
    this.$emit('close');
  }
}
